import React, { useContext } from "react";
import { AlertHolder } from "best-common-react";
import AlertContext from "../../contexts/AlertContext";
import styled from "styled-components";

const WBCAlertWrapper = styled.div`
  > div {
    > div {
      display: table;
      left: 0px;
      right: 0px;
      margin: 0 auto;
      width: fit-content;
    }
  }
`;

const WBCAlerts = () => {
  const alertContext = useContext(AlertContext);

  return (
    <WBCAlertWrapper id="amt-alerts">
      <AlertHolder
        fullWidth={false}
        alerts={alertContext.state.alerts}
        onRemove={id => {
          if (id) {
            alertContext.dispatch({ type: "removeAlert", id: id });
          }
        }}
      />
    </WBCAlertWrapper>
  );
};

export default WBCAlerts;
